// extracted by mini-css-extract-plugin
export var authorBioWrapper = "AuthorBioSection-module--author-bio-wrapper--2Dr7B";